import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
      <p className="font-heading text-8xl font-bold text-primary-500 md:text-[10rem]">404</p>
      <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">页面走丢了,正在找它</h1>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-foreground-500">
        你访问的页面可能已被移动或删除,去看看其他精彩漫画吧。
      </p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-6 py-3 text-sm font-bold text-foreground-800 transition-colors hover:border-primary-300"
        >
          <i className="ri-grid-line" aria-hidden="true" />
          浏览漫画分类
        </Link>
      </div>
    </div>
  );
}